import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import "./css/Global.css";
import './css/LandingPage.css';
import initializeStripe from "./util/InitializeStripe";
import ScrollToTop from "./util/ScrollToTop";
import { PremiumOverlay } from "./components/PremiumOverlay";
import { AuthModal } from "./components/AuthModal";
import { EmailSignUpPage } from "./pages/EmailSignUpPage";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { ConfirmationOverlay } from "./components/ConfirmationOverlay";
import { SuccessNotification } from "./components/SuccessNotification";
import { ContentOverviewModal } from "./components/ContentOverviewModal";
import { EducatorInquiryModal } from "./components/EducatorInquiryModal";

import { DesignSystem } from "./pages/DesignSystem";
import { DashboardPageV2 } from "./pages/DashboardV2";
import { GlobalStateProvider, useGlobalState } from "./GlobalState";
import {EducatorsPage} from "./pages/EducatorsPage";
import { BlogPublicPage } from "./pages/BlogPublicPage";
import { BlogPublicDetailPage } from "./pages/BlogPublicDetailPage";
import { OnboardingPage } from "./pages/OnboardingPage";
import {DashboardPageV3} from "./pages/DashboardV3";

function AppContent() {
    const { user, showPremiumOverlay, setShowPremiumOverlay, showAuthModal, showSuccessNotification, setShowSuccessNotification, showContentOverviewModal, setShowContentOverviewModal, contentOverviewModalType, showEducatorInquiryModal, setShowEducatorInquiryModal } = useGlobalState();
    const [showConfirmationOverlay, setShowConfirmationOverlay] = useState(false);
    const [overlayConfig, setOverlayConfig] = useState({
        header: '',
        text: '',
        approveText: '',
        onConfirm: () => {}
    });

    const showConfirmation = (header, text, confirmText, onConfirm) => {
        setOverlayConfig({ header, text, approveText: confirmText, onConfirm });
        setShowConfirmationOverlay(true);
    };

    React.useEffect(() => {
        try {
            initializeStripe();
        } catch (error) {
            console.error('Error initializing Stripe:', error);
        }
    }, []);

    React.useEffect(() => {
        if (process.env.REACT_APP_HOTJAR_ENABLED === 'true') {
            (function(h,o,t,j,a,r){
                h.hj = h.hj || function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid: 6376752, hjsv: 6};
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        }
    }, []);

    return (
        <>
            <Analytics />
            <SpeedInsights />
            <ScrollToTop>
                <Routes>
                    <Route path="/" element={<DashboardPageV2 />} />
                    <Route path="/educators" element={<EducatorsPage />}/>
                    <Route path="/dashboard" element={<DashboardPageV3 />} />
                    <Route path="/onboarding" element={<OnboardingPage />} />
                    <Route path="/blog-public" element={<BlogPublicPage />} />
                    <Route path="/blog-public/:blogId" element={<BlogPublicDetailPage />} />
                    <Route path="/:page/:contentId?/:subcontentId?" element={<DashboardPageV2/>}/>
                    <Route path="/designSystem" element={<DesignSystem />} />
                    <Route path="/email-signup/:type" element={<EmailSignUpPage />} />

                </Routes>
            </ScrollToTop>
            {showPremiumOverlay && <PremiumOverlay user={user} setShowPremiumOverlay={setShowPremiumOverlay} />}
            {showAuthModal && <AuthModal />}
            {showConfirmationOverlay && <ConfirmationOverlay setShowConfirmationOverlay={setShowConfirmationOverlay} overlayConfig={overlayConfig} />}
            {showContentOverviewModal && (
                <ContentOverviewModal 
                    isOpen={showContentOverviewModal}
                    onClose={() => setShowContentOverviewModal(false)}
                    contentType={contentOverviewModalType}
                />
            )}
            {showEducatorInquiryModal && (
                <EducatorInquiryModal 
                    isOpen={showEducatorInquiryModal}
                    onClose={() => setShowEducatorInquiryModal(false)}
                />
            )}
            <SuccessNotification 
                show={showSuccessNotification} 
                onClose={() => setShowSuccessNotification(false)} 
            />
        </>
    );
}

function App() {
    return (
        <GlobalStateProvider>
            <Router>
                <AppContent />
            </Router>
        </GlobalStateProvider>
    );
}

export default App;